<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="pushLink === '17' ? $t('FileHistory.SendSetOfProxyOrders') : $t('FileHistory.SendDestinationPortAgent')"
    width="750px"
    :close-on-click-modal="false"
  >
    <el-form label-width="100px" label-position="left" style="width: fit-content;margin: 5px 0 0 40px;">
      <el-form-item :label="$t('SeaExport.CompanyName')">
        <cargo-company-select
          :method-params="{ designationAgent: true }"
          :disabled="pushLink === '17'"
          :default-value="customerId || ''"
          style="width: 100%"
          @change="customerIdChange"
        />
      </el-form-item>
      <el-form-item :label="$t('SeaExport.Receiver2') + $t('SeaExport.EmailGroup')">
        <el-select
          v-model="emailGroupTo"
          filterable
          multiple
          clearable
          @change="emailGroupToChange"
        >
          <el-option
            v-for="(item, index) in emailGroupToList"
            :key="index"
            :label="item.groupName"
            :value="item.uuid"
          />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('SeaExport.Receiver2')">
        <cargo-multiple-select v-model="emailToList" filterable allow-create @change="emailToChange">
          <el-option v-for="(item, index) in finalContactList" :key="index" :label="item.name" :value="item.uuid" />
        </cargo-multiple-select>
      </el-form-item>
      <el-form-item v-if="emailGroup" :label="$t('SeaExport.Cc') + $t('SeaExport.EmailGroup')">
        <el-select
          v-model="emailGroupCc"
          filterable
          multiple
          clearable
          @change="emailGroupCcChange"
          @clear="onClearCc"
        >
          <el-option
            v-for="(item, index) in emailGroupCcList"
            :key="index"
            :label="item.groupName"
            :value="item.uuid"
          />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('Partners.CcAddress')">
        <el-input v-model="emailForm.cc" type="textarea" :rows="3" />
      </el-form-item>
      <el-form-item :label="$t('queryJob.CCPost')">
        <div style="margin: 5px 0;">
          <el-checkbox v-model="sales" @change="ccChangeHandler('sales', sales)">{{ $t('SeaExport.Sales') }}</el-checkbox>
          <el-checkbox v-model="op" @change="ccChangeHandler('op', op)">{{ $t('SeaExport.Operation') }}</el-checkbox>
          <el-checkbox v-model="csr" @change="ccChangeHandler('csr', csr)">{{ $t('SeaExport.CustomerService') }}</el-checkbox>
          <el-checkbox v-model="doc" @change="ccChangeHandler('dc', doc)">{{ $t('SeaExport.Documents') }}</el-checkbox>
          <el-checkbox v-model="emailGroup" @change="ccChangeHandler('emailGroup', emailGroup)">{{ $t('SeaExport.EmailGroup') }}</el-checkbox>
          <el-checkbox v-model="siteOP" no="siteOP" @change="ccChangeHandler('siteOP',siteOP)">{{ $t('SeaExport.FieldOperation') }}</el-checkbox>
          <el-checkbox v-model="overseaOp" no="overseaOp" @change="ccChangeHandler('overseaOp',overseaOp)">{{ $t('SeaExport.OverseaCustomerService') }}</el-checkbox>
          <el-checkbox v-model="planner" no="planner" @change="ccChangeHandler('planner',planner)">{{ $t('SeaExport.AirlinePerson2') }}</el-checkbox>
          <el-checkbox v-model="userDefinedRoleId1" no="userDefinedRoleId1" @change="ccChangeHandler('userDefinedRoleId1',userDefinedRoleId1)">{{ $t('CargoMsg.Cargo_userDefinedRole1') }}</el-checkbox>
          <el-checkbox v-model="userDefinedRoleId2" no="userDefinedRoleId2" @change="ccChangeHandler('userDefinedRoleId2',userDefinedRoleId2)">{{ $t('CargoMsg.Cargo_userDefinedRole2') }}</el-checkbox>
          <el-checkbox v-model="carbonSelf" no="carbonSelf" @change="onCarbonSelfChange">{{ $t('queryJob.CCYourself') }}</el-checkbox>
          <el-checkbox v-model="defaultCc">{{ $t('queryJob.SaveCcAddresNextDefault') }}</el-checkbox>
        </div>
      </el-form-item>
      <el-form-item :label="$t('SeaExport.mailTemplate')">
        <div style="display: flex;">
          <el-checkbox v-model="emailTemplate" @change="emailTemplateCheck" />
          <cargo-combo-box
            v-model="themeTemplate"
            :disabled="!emailTemplate"
            :allow-create="true"
            :clearable="true"
            :options="emailTemplateList"
            :label-function="titleLabelFunction"
            :placeholder-val="$t('SeaExport.placeholderVal')"
            value-field="uuid"
            :forbid-values="['']"
            style="flex: 1;margin-left: 10px;"
            @change="emailTemplateChange"
            @clear="onClearTitle"
          />
        </div>
      </el-form-item>
      <el-form-item :label="$t('SeaExport.emailSubject')">
        <el-input v-model="emailForm.title" />
      </el-form-item>
      <el-form-item :label="$t('SeaExport.MailContent')" style="height:300px;">
        <cargo-editor v-model="emailForm.mailContent" :exclude-keys="excludeKeys" style="width: 550px;height: 300px;" />
      </el-form-item>
      <el-form-item :label="$t('SeaExport.SendEMail')">
        <el-select v-model="emailForm.mailType" :placeholder="$t('SeaExport.SystemEmail')">
          <el-option v-for="(item, index) in sendEmailList" :key="index" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('Message.EmailAttachments')">
        <div style="display: flex;flex-direction: column;min-height: 28px;padding-left: 10px;border: 1px solid #EAEEF5;overflow-y: auto;height: 95px;">
          <span v-for="(item, index) in attachList" :key="index">
            {{ (index + 1) + '. ' }}
            <a
              v-if="['jpg','png','jpeg','gif','webp','pdf','doc','docx','xls','xlsx'].includes(getFileType(item.fileName))"
              style="text-decoration: underline;text-decoration-color: blue;"
              @click="handlePreviewFile(item.fileId, item.fileName)"
            >
              {{ item.fileName }}
            </a>
            <template v-else>
              {{ item.fileName }}
            </template>
            <i class="el-icon-close" style="padding: 0 2px 0 5px;font-size: 14px;color: red;font-weight: bold;cursor: pointer;" @click="removeAttach(item.fileId)" />
            <i class="el-icon-download" style="padding: 0 5px 0 3px;font-size: 14px;color: blue;font-weight: bold;cursor: pointer;" @click="downloadFile(item.fileId)" />
          </span>
        </div>
      </el-form-item>

      <div style="margin-top: -70px;padding-left:-5px;margin-bottom: 30px">
        <el-button no="fileUpload" type="primary" @click="showCloudFile()">{{ $t('FileHistory.Upload') }}</el-button>
        <br>
        <el-button no="packageDownload" :disabled="attachList.length===0" type="primary" style="margin-top: 5px" @click="batchDownload">{{ $t('queryJob.PackageDownload') }}</el-button>
      </div>
    </el-form>
    <div slot="footer" style="margin: 0 auto;width: fit-content;">
      <el-button type="primary" plain @click="localEmailClickHandler">{{ $t('SeaExport.InvokeLocalMailClient') }}</el-button>
      <el-button type="primary" @click="okClickHandler">{{ $t('CargoMsg.Cargo_Send') }}</el-button>
      <el-button @click="innerVisible = false">{{ $t('common.btn.cancel') }}</el-button>
    </div>

    <!-- 云文件上传对话框 -->
    <cargo-cloud-file-upload
      :visible.sync="cloudFile.visible"
      :job="cloudFile.job"
      :upload-source="uploadSource"
      :lob="cloudFile.lob"
      :new-file="cloudFile.newFile"
      @uploadDone="data => {uploadSuccess(data);}"
    />
    <!-- 预览文件弹窗 -->
    <pre-view-file-dialog
      :v-if="previewFileData.visible"
      :title="$t('FileHistory.preview')"
      :visible="previewFileData.visible"
      :file="previewFileData.file"
      :can-maximize="true"
      @close="closePreviewDialog"
    />
  </el-dialog>
</template>

<script>
import cargoCloudFileUpload from '@/components/Cargo/Common/cargoCloudFileUpload'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import CargoComboBox from '@/components/Cargo/Common/cargoComboBox'
import CargoEditor from '@/components/Cargo/Common/CargoEditor'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { Company } from '@/class/model/mdm/Company'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { resolveSpecificField2Value } from '@/utils/basicDataCache'
import { getLoading } from '@/utils/utilBaseElement'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import { fileHistorySendEmailService, sendEmailByInstruction } from '@/api/sendEmailService'
import { getSetMailTemplateWithAttach, getSetMailTemplateWithAttachMulti } from '@/api/sendEmailService'
import * as userApi from '@/api/user'
import { getMailGroupList } from '@/api/basicData/mailGroup'
import { doOneClickSend } from '@/api/booking/job'
import { Job } from '@/class/model/booking/Job'
import CargoMultipleSelect from '@/components/Cargo/Common/CargoMultipleSelect'
import { MAIL_ACCOUNT_5 } from '@/class/cargo/model/parameters/SystemConstants'
import preViewFileDialog from '@/components/Cargo/Common/preViewFileCommonDialog'
import URL from '@/api/urlTranslator'

export default {
  name: 'SendDestinationPortAgentEmailDialog',
  components: { cargoCompanySelect, cargoCloudFileUpload, CargoComboBox, CargoEditor, CargoMultipleSelect, preViewFileDialog },
  props: {
    visible: { type: Boolean, required: true },
    job: { type: Object, required: true },
    fileList: { type: Array, default: () => [] },
    mailTemplateUuid: { type: String, default: '' },
    pushLink: { type: String, default: '' },
    exchangeAgentData: { type: Object, default: null },
    jobContainerNoData: { type: Object, default: null },
    tenantInstruction: { type: Object, default: null },
    fileTypeOfTakeMulti: { type: String, default: '' },
    mailTemplateInterfaceType: { type: Number, default: 1 },
    ruleName: { type: String, default: '' },
    resend: { type: Boolean, default: false }
  },
  data() {
    return {
      innerVisible: this.visible,
      selectTypeNames: TYPE_NAMES,
      contactList: [],
      emailGroupToList: [], // 收件人邮件群组
      emailGroupCcList: [], // 抄送人邮件群组
      emailTemplateList: [], // 邮件模板
      emailToList: [], // 收件人邮件集合uuid
      excludeKeys: [ // 需隐藏的key
        'header1',
        'header2',
        'fontSize',
        'insertLink',
        'insertImage'
      ],
      sendEmailList: [
        {
          name: this.$t('SeaExport.SystemEmail'),
          id: '0'
        }
      ],
      customerId: 0,
      emailForm: {
        to: '',
        cc: '',
        title: '',
        content: '',
        ids: '',
        pushLink: SystemConstants.SEND_DESTINATIOIN_PORT_AGENT,
        mailType: '0',
        officeId: this.$store.getters.currentOfficeId,
        mailContent: ''
      },
      emailGroupTo: [], // 收件人邮件群组
      emailGroupToEmails: [],
      emailGroupCc: [], // 抄送邮件群组
      ccList: [],
      sales: false,
      op: false,
      csr: false,
      doc: false,
      siteOP: false,
      overseaOp: false,
      planner: false,
      userDefinedRoleId1: false,
      userDefinedRoleId2: false,
      carbonSelf: false, // 抄送自己
      emailGroup: false, // 抄送邮件群组
      defaultCc: false,
      emailTemplate: false, // 邮件模板是否勾选
      themeTemplate: '', // 选中的邮件模板
      attachList: [],
      uploadSource: 'sendDestinationPortAgentEmailDialog',
      uploadFileList: [],
      cloudFile: {
        visible: false,
        job: new Job(),
        lob: 'SE',
        newFile: null
      },
      previewFileData: {
        visible: false,
        file: null
      },
      templateAttachList: [], // 附件列表文件清单
      templateUuid: ''
    }
  },
  computed: {
    finalContactList() {
      return [...this.contactList, ...this.emailGroupToEmails]
    },
    defaultCcCacheKey() {
      if (this.mailTemplateInterfaceType === 2) {
        return 'SendDestinationPortAgentEmailMultiDialog-defaultCC'
      }
      return this.pushLink === '17' ? 'SendDestinationPortAgentEmailDialog-defaultCC17' : 'SendDestinationPortAgentEmailDialog-defaultCC'
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.onShow()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    },
    attachList(newVal) {
      if (newVal.length > 0) {
        this.emailForm.ids = Array.from(newVal, p => p.fileId).join(',')
      } else {
        this.emailForm.ids = ''
      }
    }
  },
  async created() {
    this.initEmailGroupList()
    await this.initEmailTemplateList()
    this.getEamilStatus()
    if (this.innerVisible) {
      this.onShow()
    }
  },
  methods: {
    // 获取当前用户有权限的群组
    async initEmailGroupList() {
      const params = {
        checkOwner: this.$checkPermission(['role_MailGroup_userSelf']), // 查看自己的数据及公共的数据
        checkAll: this.$checkPermission(['role_MailGroup_all']) // 查看全部数据
      }
      await getMailGroupList(params).then(res => {
        const emailGroupList = res.data.list
        if (!emailGroupList || emailGroupList.length <= 0) return
        for (const group of emailGroupList) {
          if (group.groupSceneTo) {
            this.emailGroupToList.push(group)
          }
          if (group.groupSceneCc) {
            this.emailGroupCcList.push(group)
          }
        }
      })
    },
    // 获取邮件模板
    initEmailTemplateList() {
      this.emailTemplateList = []
      const data = {
        multipleOfficeIdList: [this.$store.getters.currentOfficeId],
        branchId: this.$store.getters.currentOfficeId,
        lob: this.job.lob,
        multipleAccountIdList: [MAIL_ACCOUNT_5.code],
        pushLink: this.pushLink ? this.pushLink : SystemConstants.SEND_DESTINATIOIN_PORT_AGENT,
        mailTemplateUuid: this.mailTemplateUuid
      }
      return userApi.getMailTemplateByParams(data).then((res) => {
        this.emailTemplateList = res.data || []
      })
    },
    // 获取发送邮箱可勾选项
    async getEamilStatus() {
      //  enable：0未启用 1启用，获取当前已启用的邮箱数据
      const data = {
        branchId: this.$store.getters.currentOfficeId,
        enable: 1
      }
      const personalInfo = await userApi.getPersonalEmail(data).then(resp => resp.data)
      if (personalInfo) {
        personalInfo.map((item) => {
          switch (item.mailType) {
            case '1':
              this.sendEmailList.push({
                name: this.$t('SeaExport.CompanyMail'),
                id: '1'
              })
              break
            case '2':
              this.sendEmailList.push({
                name: this.$t('SeaExport.PersonalMailbox'),
                id: '2'
              })
              break
          }
        })
      }
      const cacheKey = this.mailTemplateInterfaceType === 2 ? `SendDestinationPortAgentEmailMultiDialog-${this.pushLink}-mailType` : `SendDestinationPortAgentEmailDialog-${this.pushLink}-mailType`
      const mailType = LocalStorageUtilsNew.getConfiguration(cacheKey, 'string')
      if (mailType && this.sendEmailList.findIndex(p => p.id === mailType) > -1) {
        this.emailForm.mailType = mailType
      }
    },
    async onShow() {
      const pushLink = this.pushLink ? this.pushLink : SystemConstants.SEND_DESTINATIOIN_PORT_AGENT
      if (this.emailTemplateList.length === 0 || this.emailTemplateList[0].pushLink !== pushLink) {
        await this.initEmailTemplateList()
      }
      this.emailToList = []
      this.emailGroupTo = []
      this.emailGroupToEmails = []
      if (this.jobContainerNoData) {
        if (this.jobContainerNoData.exchangeAgent) {
          this.customerId = this.jobContainerNoData.exchangeAgent
        } else {
          this.customerId = this.job.destinationAgent
        }
      } else {
        if (this.exchangeAgentData) {
          this.customerId = this.exchangeAgentData.exchangeAgent
        } else {
          this.customerId = this.job.destinationAgent
        }
      }
      await this.customerIdChange({ cmpIdx: this.customerId })
      this.reloadDefaultEmailChange()
      this.emailForm.title = ''
      this.emailTemplate = true
      this.emailForm.content = ''
      this.emailForm.mailContent
      this.uploadFileList = [...this.fileList]
      this.attachList = this.uploadFileList
      if (this.emailTemplateList.length > 0) {
        this.emailTemplateChange(this.emailTemplateList[0].uuid, true)
      }
      this.cloudFile.job = this.job
      this.cloudFile.lob = this.job.lob
    },
    async customerIdChange(company) {
      this.emailForm.to = ''
      this.emailForm.cc = ''
      this.contactList = []
      company = new Company(company)
      const contacts = await company.getContactsBycmpIdx()
      this.buildContactsData(contacts)
    },
    buildContactsData(contacts) {
      const newContactList = []
      let defalutContactEmail = ''
      let defalutCcAddress = ''
      let defalutContactEmailItem = null
      if (contacts && contacts.length > 0) {
        for (const item of contacts) {
          const obj = {
            name: `[${item.contactPerson}]${item.email}`,
            contact: item.contactPerson,
            email: item.email,
            uuid: item.uuid
          }
          if (item.defaultContact) {
            defalutContactEmail = item.email
            defalutCcAddress = item.ccAddress
            defalutContactEmailItem = obj
          }
          newContactList.push(obj)
        }
      }
      this.contactList = newContactList
      if (this.contactList && this.contactList.length > 0) {
        if (defalutContactEmail) {
          this.emailForm.to = defalutContactEmail
          this.emailForm.cc = defalutCcAddress
          this.addEmailToList(defalutContactEmailItem)
        } else {
          this.emailForm.to = this.contactList[0].email
          this.addEmailToList(this.contactList[0])
        }
      }
    },
    // 部分邮件实体实际没有email，但是页面上要显示用户名称
    addEmailToList(emailItem) {
      if (!this.emailToList) {
        this.emailToList = []
      }
      const i = this.emailToList.findIndex(item => item.uuid === emailItem.uuid)
      if (i < 0) {
        this.emailToList.push(emailItem.uuid)
      }
    },
    async reloadDefaultEmailChange() {
      this.sales = false
      this.op = false
      this.csr = false
      this.doc = false
      this.emailGroup = false
      this.defaultCc = false
      this.siteOP = false
      this.overseaOp = false
      this.planner = false
      this.userDefinedRoleId1 = false
      this.userDefinedRoleId2 = false
      this.carbonSelf = false
      let cc = this.emailForm.cc
      if (cc !== '') {
        cc = cc.replace(/\n/g, '')
        this.ccList = cc.split(',')
      } else {
        this.ccList = []
      }
      const ccItem = LocalStorageUtilsNew.getConfiguration(this.defaultCcCacheKey)
      if (ccItem) {
        if (ccItem.hasOwnProperty('sales')) {
          this.sales = true
          const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.sales, 'email')
          if (userEmail !== '') {
            this.ccList.push(userEmail)
          }
        }
        if (ccItem.hasOwnProperty('op')) {
          this.op = true
          const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.op, 'email')
          if (userEmail !== '') {
            this.ccList.push(userEmail)
          }
        }
        if (ccItem.hasOwnProperty('csr')) {
          this.csr = true
          const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.csr, 'email')
          if (userEmail !== '') {
            this.ccList.push(userEmail)
          }
        }
        if (ccItem.hasOwnProperty('doc')) {
          this.doc = true
          const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.dc, 'email')
          if (userEmail !== '') {
            this.ccList.push(userEmail)
          }
        }
        if (ccItem.hasOwnProperty('siteOP')) {
          this.siteOP = true
          const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.siteOP, 'email')
          if (userEmail !== '') {
            this.ccList.push(userEmail)
          }
        }
        if (ccItem.hasOwnProperty('overseaOp')) {
          this.overseaOp = true
          const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.overseaOp, 'email')
          if (userEmail !== '') {
            this.ccList.push(userEmail)
          }
        }
        if (ccItem.hasOwnProperty('planner')) {
          this.planner = true
          const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.planner, 'email')
          if (userEmail !== '') {
            this.ccList.push(userEmail)
          }
        }
        if (ccItem.hasOwnProperty('userDefinedRoleId1')) {
          this.userDefinedRoleId1 = true
          const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.userDefinedRoleId1, 'email')
          if (userEmail !== '') {
            this.ccList.push(userEmail)
          }
        }
        if (ccItem.hasOwnProperty('userDefinedRoleId2')) {
          this.userDefinedRoleId2 = true
          const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.userDefinedRoleId2, 'email')
          if (userEmail !== '') {
            this.ccList.push(userEmail)
          }
        }
        if (ccItem.hasOwnProperty('carbonSelf')) {
          this.carbonSelf = true
          const user = this.$store.getters.userInfo
          if (user.email) {
            this.ccList.push(user.email)
          }
        }
        if (ccItem.hasOwnProperty('defaultCc')) {
          this.defaultCc = true
        }
        // 从缓存中获取邮件组选项，抄送邮件群组
        if (ccItem.hasOwnProperty('emailGroup')) {
          this.emailGroup = ccItem.emailGroup
        }
        if (ccItem.hasOwnProperty('emailGroupCc')) {
          this.emailGroupCc = ccItem.emailGroupCc ? ccItem.emailGroupCc.split(',') : []
        }
      }
      // 如果自己有操作，销售，单证，客户权限则默认选中
      // if (this.$checkPermission(['role_sales']) && this.job.sales !== '' && !this.sales) {
      //   const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.sales, 'email')
      //   if (userEmail !== '') {
      //     this.sales = true
      //     this.ccList.push(userEmail)
      //   }
      // }
      // if (this.$checkPermission(['role_op']) && this.job.op !== '' && !this.op) {
      //   const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.op, 'email')
      //   if (userEmail !== '') {
      //     this.op = true
      //     this.ccList.push(userEmail)
      //   }
      // }
      // if (this.$checkPermission(['role_csr']) && this.job.csr !== '' && !this.csr) {
      //   const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.csr, 'email')
      //   if (userEmail !== '') {
      //     this.csr = true
      //     this.ccList.push(userEmail)
      //   }
      // }
      // if (this.$checkPermission(['role_doc']) && this.job.dc !== '' && !this.doc) {
      //   const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.dc, 'email')
      //   if (userEmail !== '') {
      //     this.doc = true
      //     this.ccList.push(userEmail)
      //   }
      // }
      // 用户组勾选了 ，在把用户组加上
      if (this.emailGroup && this.emailGroupCc && this.emailGroupCc.length > 0) {
        this.emailGroupCcChange(this.emailGroupCc)
      } else {
        // 刷新CC内容
        this.refreshCcTxt()
      }
    },
    // 收件人邮件群组改变
    emailGroupToChange(items) {
      const emails = []
      for (const option of this.emailGroupToList) {
        if (items.includes(option.uuid) && option.emailAddress) {
          const items = option.emailAddress.split('\n')
          for (const item of items) {
            // 去掉【;】之后，对比是否重复
            const email = item.replaceAll(';', '')
            if (!emails.includes(email)) {
              emails.push(email)
            }
          }
        }
      }
      this.emailGroupToEmails = Array.from(emails, p => {
        return { uuid: p, name: p }
      })
      this.emailToList = emails
      this.emailToChange(emails)
    },
    refreshCcTxt(emailList) {
      let ccList = [...new Set(this.ccList)]
      if (emailList) {
        ccList = emailList
      }
      let ccEmail = ''
      for (let i = 0; i < ccList.length; i++) {
        if (ccEmail === '') {
          ccEmail = ccList[i]
        } else {
          ccEmail = ccEmail + ',\n' + ccList[i]
        }
      }
      this.emailForm.cc = ccEmail
    },
    emailToChange(val) {
      const emails = []
      for (const data of val) {
        if (this.contactList && this.contactList.length > 0) {
          for (const option of this.contactList) {
            if (data === option.uuid && option.email) {
              emails.push(option.email.replaceAll(';', ','))
            } else if (data.includes('@') && !emails.includes(data)) {
              emails.push(data)
            }
          }
        } else {
          if (data.includes('@') && !emails.includes(data)) {
            emails.push(data)
          }
        }
      }
      this.emailForm.to = emails.join(',')
    },
    // 抄送邮件群组改变
    emailGroupCcChange(items) {
      // 去除重复的
      const ccList = [...new Set(this.ccList)]
      // 默认添加上已经选择的其他类型抄送人
      const emails = ccList ? ccList.map(da => da.replaceAll(',', '')) : []
      for (const option of this.emailGroupCcList) {
        if (items.includes(option.uuid) && option.emailAddress) {
          const items = option.emailAddress.split('\n')
          for (const item of items) {
            // 去掉;之后 对比是否重复
            const email = item.replaceAll(';', '')
            if (!emails.includes(email)) {
              emails.push(email)
            }
          }
        }
      }
      // 刷新CC内容
      this.refreshCcTxt(emails)
    },
    // 清空抄送人
    onClearCc() {
      this.emailGroupCc = ''
      this.emailForm.cc = ''
    },
    // 抄送信息改变
    ccChangeHandler(p, check) {
      // 邮件群组移除群组相关邮箱
      if (p === 'emailGroup') {
        return
      }
      if (this.job[p] !== '') {
        const email = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job[p], 'email')
        if (check) {
          if (email !== '' && !this.ccList.includes(email)) {
            this.ccList.push(email)
          }
        } else {
          this.ccList = this.ccList.filter(value => {
            return value !== email
          })
        }
      }
      // 用户组勾选了 ，在把用户组加上
      if (this.emailGroup && this.emailGroupCc && this.emailGroupCc.length > 0) {
        this.emailGroupCcChange(this.emailGroupCc)
      } else {
        // 刷新CC内容
        this.refreshCcTxt()
      }
    },
    // 抄送自己改变
    onCarbonSelfChange() {
      const email = this.$store.getters.userInfo.email
      if (this.carbonSelf) {
        if (email !== '' && !this.ccList.includes(email)) {
          this.ccList.push(email)
        }
      } else {
        this.ccList = this.ccList.filter(value => {
          return value !== email
        })
      }
      // 用户组勾选了 ，在把用户组加上
      if (this.emailGroup && this.emailGroupCc && this.emailGroupCc.length > 0) {
        this.emailGroupCcChange(this.emailGroupCc)
      } else {
        // 刷新CC内容
        this.refreshCcTxt()
      }
    },
    // 勾选邮件模板
    emailTemplateCheck() {
      if (!this.emailTemplate) {
        this.themeTemplate = ''
      }
    },
    // 主题模板
    titleLabelFunction(item) {
      if (item.templateName) {
        return `${item.templateName}`
      } else {
        return ' '
      }
    },
    // 邮件模板改变
    emailTemplateChange(item, isInit = false) {
      if (!item) {
        return
      }
      const option = this.emailTemplateList.find(p => p.uuid === item)
      this.themeTemplate = option ? option.templateName : ''
      const content = option ? option.contentTemplate : ''
      this.emailForm.content = content
      if (isInit ? !this.defaultCc : true) {
        this.sales = option ? option.sales : ''
        this.op = option ? option.op : ''
        this.csr = option ? option.csr : ''
        this.doc = option ? option.doc : ''
        this.siteOP = option ? option.siteOp : ''
        this.overseaOp = option ? option.overseaOp : ''
        this.planner = option ? option.planner : ''
        this.userDefinedRoleId1 = option ? option.userDefinedRoleId1 : ''
        this.userDefinedRoleId2 = option ? option.userDefinedRoleId2 : ''
        this.emailGroup = option ? option.emailGroup : ''
        this.emailGroupCc = option && option.emailGroupCc ? option.emailGroupCc.split(',') : []
      }
      this.getSetMailTemplateFunc(item)
    },
    // 获取邮件内容
    async getSetMailTemplateFunc(templateUuid) {
      let ajaxResult = null
      if (this.mailTemplateInterfaceType === 2) {
        ajaxResult = getSetMailTemplateWithAttachMulti({
          jobUuids: [this.job.uuid],
          lob: this.job.lob,
          branchId: this.$store.getters.currentOfficeId,
          templateUuid,
          fileTypeOfTakeMulti: this.fileTypeOfTakeMulti
        })
      } else {
        const data = {
          jobUuid: this.job.uuid,
          pushLink: this.pushLink ? this.pushLink : SystemConstants.SEND_DESTINATIOIN_PORT_AGENT,
          templateUuid,
          exchangeAgent: 0,
          fileTypeOfTakeMulti: this.fileTypeOfTakeMulti
        }
        if (this.pushLink === '17') {
          if (this.jobContainerNoData) {
            if (this.jobContainerNoData.exchangeAgent) {
              data.exchangeAgent = this.jobContainerNoData.exchangeAgent
            }
          } else if (this.exchangeAgentData) {
            if (this.exchangeAgentData.exchangeAgent) {
              data.exchangeAgent = this.exchangeAgentData.exchangeAgent
            }
          }
        }
        if (this.jobContainerNoData) {
          data.containerNo = this.jobContainerNoData.containerNo
          data.containerJobKeys = this.jobContainerNoData.jobKeys
        }
        ajaxResult = getSetMailTemplateWithAttach(data)
      }
      const loading = getLoading()
      const res = await ajaxResult.finally(() => { loading.close() })
      const { template, attachList } = res.data
      this.emailForm.title = template.themeTemplate
      this.emailForm.content = template.contentTemplate ? template.contentTemplate.replace(/ /g, '&nbsp;') : ''
      this.emailForm.mailContent = template.contentTemplate ? template.contentTemplate.replace(/ /g, '&nbsp;') : ''
      this.attachList = [...this.uploadFileList]
      const fileIdSet = new Set(Array.from(this.attachList, p => p.fileId))
      for (const item of attachList) {
        if (item.isExist) {
          if (item.files) {
            for (const file of item.files) {
              if (fileIdSet.has(file.fileId)) {
                continue
              }
              this.attachList.push({ fileId: file.fileId, fileName: file.fileName, jobNo: file.jobNo })
              fileIdSet.add(file.fileId)
            }
          } else if (item.fileId && item.fileName && !fileIdSet.has(item.fileId)) {
            this.attachList.push({ fileId: item.fileId, fileName: item.fileName, jobNo: item.jobNo })
            fileIdSet.add(item.fileId)
          }
        }
      }
      this.uploadFileList = this.attachList
      this.templateAttachList = attachList
      this.templateUuid = templateUuid
    },
    // 清空标题
    onClearTitle() {
      this.emailForm.title = ''
    },
    removeAttach(fileId) {
      this.$confirm(this.$t('Message.DeleteAttachTip'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        this.uploadFileList = this.attachList = this.attachList.filter(p => p.fileId !== fileId)
      }).catch(() => {})
    },
    // 邮件发送
    async okClickHandler() {
      if (!this.toCheckEmailForm()) {
        return
      }
      // 保存默认抄送人
      this.saveCCEmail()
      const cacheKey = this.mailTemplateInterfaceType === 2 ? `SendDestinationPortAgentEmailMultiDialog-${this.pushLink}-mailType` : `SendDestinationPortAgentEmailDialog-${this.pushLink}-mailType`
      LocalStorageUtilsNew.setConfiguration(cacheKey, this.emailForm.mailType)
      this.emailForm.cc = this.emailForm.cc.replace(/\n/g, '')
      this.emailForm.content = this.emailForm.mailContent.replace(/ /g, '&nbsp;')
      const content = this.emailForm.content ? this.emailForm.content.split('\n').join('<br/>') : ''
      let toName = ''
      for (const contact of this.contactList) {
        if (contact.email === this.emailForm.to) {
          toName = contact.name
        }
      }
      const emailForm = {}
      Object.assign(emailForm, this.emailForm)
      emailForm.content = content
      emailForm.mailContent = this.appendTableStyle(emailForm.mailContent)
      emailForm.jobNo = this.job.jobNo
      emailForm.toName = toName // 收件人姓名
      const loading = getLoading()
      try {
        if (this.tenantInstruction && !this.resend) {
          emailForm.tenantInstructionUuid = this.tenantInstruction.uuid
          emailForm.platformInstructionCode = this.tenantInstruction.platformInstructionCode
          emailForm.allowMultipleOperations = this.tenantInstruction.allowMultipleOperations
          emailForm.branchId = this.$store.getters.currentOfficeId
          emailForm.jobUuids = this.job.uuid
          if (this.jobContainerNoData) {
            emailForm.containerNo = this.jobContainerNoData.containerNo
            emailForm.exchangeAgent = this.jobContainerNoData.exchangeAgent
          } else if (this.exchangeAgentData) {
            emailForm.exchangeAgent = this.exchangeAgentData.exchangeAgent
          } else {
            emailForm.exchangeAgent = 0
          }
          await sendEmailByInstruction(emailForm)
        } else {
          await fileHistorySendEmailService(emailForm)
        }
        await this.emailSuccessNext()
      } catch (e) {
        if (this.tenantInstruction) {
          // 生成指令执行日志
          this.$emit('instructionCallback', { jobUuids: [this.job.uuid], executeStatus: false })
        }
      } finally {
        loading.close()
      }
    },
    // 附加表格样式
    appendTableStyle(mailContent) {
      const items = mailContent.match(/<table[^>]*>/g)
      if (items) {
        for (const item of items) {
          let newItem = item
          const index = newItem.indexOf('class="')
          if (index > -1) {
            newItem = newItem.replace('class="', 'class="cargoware ')
          } else {
            newItem = newItem.replace('<table', '<table class="cargoware"')
          }
          mailContent = mailContent.replace(item, newItem)
        }
      }
      return `
      <style type="text/css">
        table.cargoware {
           border: 1px solid #ccc;
           border-left: none;
           border-collapse: collapse;
        }
        table.cargoware tr th {
          border-left: 1px solid #ccc;
          padding: 3px 5px;
          background-color: #f5f2f0;
          color: #333;
        }
        table.cargoware tr td {
          border-top: 1px solid #ccc;
          border-left: 1px solid #ccc;
          padding: 3px 5px;
          color: #333;
        }
      </style>` + mailContent
    },
    toCheckEmailForm() {
      let errorMsg = ''
      if (!this.emailForm.to) {
        errorMsg += this.$t('Message.EmailAddressCannotBeEmpty')
      }
      if (this.emailGroup && this.emailForm.cc) { // 抄送群组
        this.emailForm.cc = this.emailForm.cc.replaceAll('\n', '')
        this.emailForm.cc = this.emailForm.cc.replaceAll(';', ',')
      }
      if (errorMsg) {
        this.$message.error(errorMsg)
        return false
      } else {
        return true
      }
    },
    // 保存默认抄送人
    saveCCEmail() {
      const ccObject = {}
      if (this.defaultCc) {
        if (this.sales) {
          ccObject.sales = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.sales, 'email')
        }
        if (this.op) {
          ccObject.op = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.op, 'email')
        }
        if (this.csr) {
          ccObject.csr = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.csr, 'email')
        }
        if (this.doc) {
          ccObject.doc = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.dc, 'email')
        }
        if (this.siteOP) {
          ccObject.siteOP = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.siteOP, 'email')
        }
        if (this.overseaOp) {
          ccObject.overseaOp = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.overseaOp, 'email')
        }
        if (this.planner) {
          ccObject.planner = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.planner, 'email')
        }
        if (this.userDefinedRoleId1) {
          ccObject.userDefinedRoleId1 = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.userDefinedRoleId1, 'email')
        }
        if (this.userDefinedRoleId2) {
          ccObject.userDefinedRoleId2 = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.userDefinedRoleId2, 'email')
        }
        if (this.carbonSelf) {
          ccObject.carbonSelf = this.carbonSelf
        }
        if (this.defaultCc) {
          ccObject.defaultCc = this.defaultCc
        }
        if (this.emailGroup) {
          ccObject.emailGroup = this.emailGroup
        }
        if (this.emailGroupCc) {
          ccObject.emailGroupCc = this.emailGroupCc.join(',')
        }
      }
      LocalStorageUtilsNew.setConfiguration(this.defaultCcCacheKey, ccObject)
    },
    localEmailClickHandler() {
      const mailContent = this.appendTableStyle(this.emailForm.mailContent)
      const url = 'mailto:' + this.emailForm.to + '?subject=' + this.emailForm.title + '&cc=' + this.emailForm.cc + '&body=' + mailContent
      if (url.length > 2048) {
        this.$message.warning(this.$t('Message.LocalEmailTooLarge'))
        return
      }
      parent.location.href = url
      this.$confirm(this.$t('Message.LocalEmailSentSuccess'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(async() => {
        const loading = getLoading()
        try {
          await this.emailSuccessNext(true)
        } finally {
          loading.close()
        }
      }).catch(() => {})
    },
    showCloudFile(newFile = null) {
      this.cloudFile.newFile = newFile
      this.cloudFile.visible = true
    },
    uploadSuccess(rowData) {
      console.log(rowData)
      for (const data of rowData) {
        if (data.fileId) {
          const d = { fileId: data.fileId, fileName: data.fileName, createDate: data.createDate }
          this.uploadFileList.push(d)
        }
      }
      this.attachList = this.uploadFileList
    },
    async emailSuccessNext(isLocalEmail = false, content = '') {
      const data = { uuid: this.job.uuid, isLocalEmail }
      if (isLocalEmail) {
        const contact = this.contactList.find(p => p.email === this.emailForm.to)
        data.name = contact ? contact.name : ''
        data.email = this.emailForm.to
        data.content = content
      }
      if (this.jobContainerNoData) {
        data.jobContainerNoUuid = this.jobContainerNoData.uuid
        data.containerNo = this.jobContainerNoData.containerNo
        data.containerJobKeys = this.jobContainerNoData.containerJobKeys
        data.exchangeAgent = this.jobContainerNoData.exchangeAgent
      } else if (this.exchangeAgentData) {
        data.jobExchangeAgentUuid = this.exchangeAgentData.uuid
        data.exchangeAgent = this.exchangeAgentData.exchangeAgent
      }
      const template = this.emailTemplateList.find(p => p.templateName === this.themeTemplate)
      if (template) {
        data.sendLockSlaveHblAndVirtualBill = template.sendLockSlaveHblAndVirtualBill
        data.sendLockExchangeAgentHblAndVirtualBill = template.sendLockExchangeAgentHblAndVirtualBill
      }
      const fileIds = []
      const jobNos = []
      for (const file of this.attachList) {
        fileIds.push(file.fileId)
        jobNos.push(file.jobNo)
      }
      data.fileIds = fileIds
      data.jobNos = jobNos
      if (this.tenantInstruction) {
        data.templateAttachList = this.templateAttachList
        data.platformInstructionCode = this.tenantInstruction.platformInstructionCode
        data.ruleName = this.ruleName
        data.templateUuid = this.templateUuid
        data.pushLink = this.pushLink
      }
      const forecastResend = this.job[this.tenantInstruction.platformInstructionCode + 'Resend']
      if (forecastResend) {
        data.oneClickForecastResendKeys = [forecastResend.uuid]
      }
      const res = await doOneClickSend(data)
      this.$nextTick(() => {
        this.$emit('callback', res.data)
        if (this.tenantInstruction) {
          // 生成指令执行日志
          this.$emit('instructionCallback', { jobUuids: [this.job.uuid], executeStatus: true })
        }
      })
      this.innerVisible = false
      this.$message({ type: 'success', message: this.$t(`Message.TheFileIsSentSuccessfully`) })
    },
    // 获取文件后缀名
    getFileType(fileName) {
      const index = fileName.lastIndexOf('.')
      if (index > -1) {
        return fileName.substring(index + 1)
      }
      return ''
    },
    handlePreviewFile(fileId, fileName) {
      this.previewFileData.file = { fileId, fileName }
      this.previewFileData.visible = true
    },
    closePreviewDialog() {
      this.previewFileData.file = null
      this.previewFileData.visible = false
    },
    downloadFile(fileId) {
      const url = URL.common.findByFileId + `/${fileId}?sessionId=${this.$store.getters.userInfo.sessionId}`
      window.open(url)
    },
    batchDownload() {
      const fileIds = Array.from(this.attachList, p => p.fileId).reduce((a, b) => a + ',' + b)
      const fileName = this.job.jobNo + '.zip'
      window.open(`${URL.common.compressFiles}?sessionId=${this.$store.getters.userInfo.sessionId}&fileIds=${fileIds}&fileName=${fileName}`)
    }
  }
}
</script>
